module.exports = __webpack_public_path__ + "02_long_yellow.42538f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_long_yellow.png
// module id = ltiq
// module chunks = 0